import { shallowEqual, useSelector } from 'react-redux';
var useSelectedDuplicateTransactions = function () {
    return useSelector(function (_a) {
        var duplicateTransactions = _a.questionnaire.duplicateTransactions;
        var selectedDuplicateTransactions = duplicateTransactions === null || duplicateTransactions === void 0 ? void 0 : duplicateTransactions.filter(function (txn) { return txn.selected; });
        return {
            selectedDuplicateTransactions: selectedDuplicateTransactions
        };
    }, shallowEqual);
};
export default useSelectedDuplicateTransactions;
//# sourceMappingURL=useDuplicateTransactions.js.map